var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-view'),(_vm.isLogged)?_c('ModalFeedback'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }